import React, { useEffect, useState } from "react";
import "./AddReportForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import MenuItem from "@mui/material/MenuItem";
import useEdit from "../../../../Hooks/useEdit";
import useSave from "../../../../Hooks/useSave";
import {
  classesURL,
  courseListURL,
  courseURL,
  schoolListURL,
  teacherListURL,
} from "../../../../Hooks/URL";
import { Formik } from "formik";
import * as Yup from "yup";
import useFetch from "../../../../Hooks/useFetch";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Autocomplete } from "@mui/material";

const ReportSchema = Yup.object().shape({
  month: Yup.number().required("Month is required"),
});

function AddReportForm({ Edit = false, Class, url }) {
  const navigate = useNavigate();
  const [newObject, setNewObject] = useState({});
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const { state, loading: editLoading } = useEdit(
    url,
    goEdit,
    setGoEdit,
    newObject,
    false,
    false
  );
  const { saveState, loading: addLoading } = useSave({
    url: `${classesURL}/${Class?.id}/class-feedbacks`,
    goSave,
    setGoSave,
    newObject,
  });

  useEffect(() => {
    if (state.dataRes.status == "success") {
      navigate(`/classes/${Class?.id}`);
    }
  }, [state]);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      navigate(`/classes/${Class?.id}`);
    }
  }, [saveState]);

  const monthsList = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ];

  return (
    <div className="CourseSmallFormWrapper">
      <Formik
        initialValues={{
          month: Edit ? Class?.month ?? null : null,
        }}
        validationSchema={ReportSchema}
        onSubmit={(values) => {
          if (Edit) {
            const prev = {
              month: Class?.month ?? null,
            };
            const newObj = { month: values.month };
            setNewObject(
              Object.fromEntries(
                Object.entries({
                  ...prev,
                  ...newObj,
                }).filter(([key]) => prev[key] != newObj[key])
              )
            );
            setGoEdit(true);
          } else {
            setNewObject({ month: values.month });
            setGoSave(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          setValues,
          handleChange,
          handleBlur,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="ClassFormContainer">
              <div style={{ width: "100%", marginTop: "20px" }}>
                <label className="aboutLabel" style={{ marginBottom: "5px" }}>
                  Report Month:
                </label>

                <TextFieldInput
                  select
                  newValue={values.month}
                  name={"month"}
                  change={handleChange}
                  blur={handleBlur}
                  fullWidth
                  className={`Input`}
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="teacherSelect" disabled>
                    Choose Month
                  </MenuItem>
                  {monthsList?.map((monthItem) => (
                    <MenuItem value={monthItem?.id}>{monthItem?.name}</MenuItem>
                  ))}
                </TextFieldInput>
                {errors.month && touched.month && errors.month && (
                  <p className="error">
                    {errors.month && touched.month && errors.month}
                  </p>
                )}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                className="actionButton primary addButton"
                onClick={handleSubmit}
                disabled={Edit ? editLoading : addLoading}
              >
                {Edit ? (
                  editLoading ? (
                    <PulseLoader color="white" size={8} />
                  ) : (
                    "Edit"
                  )
                ) : addLoading ? (
                  <PulseLoader color="white" size={8} />
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddReportForm;
